<template>
  <chart-container @onCSVDownload="downloadCSVGraphs(titleChart)" :titleChart="titleChart" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="downloadId" :specificSiteId="specificSiteId" :downloadShow="dataExists" :zoomGraphValue="zoomGraphValue">
    <span slot="header" class="float-right enrol-tabs">
      <b-tabs v-model="tabQueryStatus">
        <b-tab v-for="(tabName, index) in tabListOverallQueryStatus" :key="index" :title="tabName" @click="onTabChange(tabName)" />
      </b-tabs>
    </span>
    <fusioncharts style="width: 100%;" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" slot="body" v-if="dataExists"> </fusioncharts>
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>

<script>
import { downloadCSV, getContrast, getSiteID, primaryColorFnc } from "../../services/visualization/data-management";
import ChartContainer from "@/components/containers/chart-container";
import * as srv from "@/services/visualization/data-management";

export default {
  components: { ChartContainer },
  props: {
    queriesRaw: { type: [Object, Array], default: () => [] },
    tabListOverallQueryStatus: { type: [Object, Array], default: () => [] },
    downloadId: { type: String, default: "" },
    xAxisName: { type: String, default: "" },
    yAxisName: { type: String, default: "" },
    sitesSelected: { type: Array, default: () => ["all"] },
    countrySelected: { default: () => "all" },
    zoomGraphValue: { type: String, default: "" },
    specificSiteId: { type: Array, default: () => {} },
    tab: { default: 0 },
    titleChart: { type: String, default: "" },
    dataLoaded: { type: Boolean, default: false },
    filterTriggered: { type: Boolean, default: false }
  },
  data() {
    return {
      dataExists: false,
      xAxisNameQueriesStatusData: "Days",
      tabQueryStatus: 0,
      type: "stackedcolumn2d",
      dataFormat: "json",
      renderAt: "chart-container",
      width: "100%",
      height: "240",
      dataOpen: [],
      dataResponded: [],
      dataClosed: [],
      category: [],
      dataSource: {
        chart: {
          chartTopMargin: 0,
          xAxisNameFontColor: "#959fa4",
          xAxisNameFont: "RobotoMedium",
          xAxisNameFontSize: "9px",
          labelFontSize: "10px",
          labelFont: "RobotoRegular",
          labelFontColor: "#a3a3a3",
          yAxisNameFont: "RobotoMedium",
          yAxisNameFontSize: "9px",
          yAxisValueFont: "RobotoMedium",
          yAxisValueFontSize: "10px",
          yAxisValueFontColor: "#a3a3a3",
          legendItemFont: "RobotoRegular",
          legendItemFontColor: "#666669",
          legendCaptionAlignment: "center",
          baseFont: "'Roboto', sans-serif",
          baseFontColor: "#a3a3a3",
          xAxisname: this.xAxisName,
          yAxisName: this.yAxisName,
          theme: "fusion",
          legendItemFontSize: "10px",
          yAxisNameFontColor: "#959fa4",
          divLineAlpha: "0",
          divLineDashed: "0",
          legendPosition: "top-right",
          baseFontSize: "10",
          maxColWidth: "57",
          showXAxisLine: true,
          showYAxisLine: true,
          xaxislinethickness: "1",
          yaxislinethickness: "1",
          xAxisLineColor: "#b0bac9",
          yAxisLineColor: "#b0bac9",
          tooltipBorderAlpha: "0",
          toolTipBgAlpha: "0",
          chartBottomMargin: "0",
          xAxisNamePadding: "5",
          decimals: 0,
          labelDisplay: "wrap",
          maxLabelHeight: "30",
          useEllipsesWhenOverflow: "1"
        },
        dataset: [
          {
            seriesname: "Open",
            tooltipborderradius: "5",
            data: this.dataOpen,
            color: primaryColorFnc(),
            plotToolText: `
                <div class="overall-collection-metric-tooltip completed" style='color:${getContrast(primaryColorFnc())}'>
                   <span>$label</span></br>
                   $dataValue Querie(s) Open
                </div>
            `,
            toolTipBgColor: primaryColorFnc()
          },
          {
            seriesname: "Responded{br}(Not Closed)",
            color: "#cab2d6",
            plotToolText: `
                <span class="overall-collection-metric-tooltip missing" style='color:${getContrast("#cab2d6")}'>
                    $dataValue Querie(s) Responded (Not Closed)
                </span>
            `,
            data: this.dataResponded
          },
          {
            seriesname: "Closed",
            color: "#a6cee3",
            plotToolText: `
                <span class="overall-collection-metric-tooltip verified" style='color:${getContrast("#a6cee3")}'>
                   $dataValue Querie(s) Closed
                </span>
            `,
            data: this.dataClosed
          }
        ]
      },
      zoomGraphValueChild: "",
      todayDate: "",
      tDateShow: true,
      getSiteID,
      choosentab: this.xAxisName
    };
  },
  watch: {
    filterTriggered: function() {
      const queriesStatusData = srv.getQueriesStatusData(this.queriesRaw, this.countrySelected, this.sitesSelected, this.tabQueryStatus);
      this.category = queriesStatusData.category;
      this.dataOpen = queriesStatusData.dataOpen;
      this.dataResponded = queriesStatusData.dataResponded;
      this.dataClosed = queriesStatusData.dataClosed;
      this.dataExists = this.dataSource.categories && Object.keys(this.dataSource.categories).length > 0;
    },
    category: function(newValue) {
      if (newValue) {
        this.dataSource.categories = [{}];
        this.dataSource.categories[0].category = newValue;
      } else {
        this.dataSource.categories = [];
      }
      this.dataExists = this.dataSource.categories && Object.keys(this.dataSource.categories).length > 0;
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "240";
      }
    },
    dataOpen: function(newValue) {
      this.dataSource.dataset[0].data = newValue;
      this.dataSource.dataset[0].color = primaryColorFnc();
      this.dataSource.dataset[0].toolTipBgColor = primaryColorFnc();
      if (this.tabQueryStatus === 0) {
        this.dataSource.dataset[0].plotToolText = `
          <span class="overall-collection-metric-tooltip completed" style='color:${getContrast(primaryColorFnc())}'>
              $dataValue Querie(s) Open
          </span>`;
      } else {
        this.dataSource.dataset[0].plotToolText = `
          <div class="overall-collection-metric-tooltip completed" style='color:${getContrast(primaryColorFnc())}'>
              <span>$label</span></br>
              $dataValue Querie(s) Open
          </div>`;
      }
      this.dataExists = this.dataSource.categories && Object.keys(this.dataSource.categories).length > 0;
    },
    dataResponded: function(newValue) {
      this.dataSource.dataset[1].data = newValue;
      if (this.tabQueryStatus === 0) {
        this.dataSource.dataset[1].plotToolText = `
          <span class="overall-collection-metric-tooltip missing" style='color:${getContrast("#cab2d6")}'>
              $dataValue Querie(s) Responded (Not Closed)
          </span>`;
      } else {
        this.dataSource.dataset[1].plotToolText = `
          <div class="overall-collection-metric-tooltip missing" style='color:${getContrast("#cab2d6")}'>
              <span>$label</span></br>
              $dataValue Querie(s) Responded (Not Closed)
          </div>`;
      }
      this.dataExists = this.dataSource.categories && Object.keys(this.dataSource.categories).length > 0;
    },
    dataClosed: function(newValue) {
      this.dataSource.dataset[2].data = newValue;

      if (this.tabQueryStatus === 0) {
        this.dataSource.dataset[2].plotToolText = `
          <span class="overall-collection-metric-tooltip verified" style='color:${getContrast("#a6cee3")}'>
              $dataValue Querie(s) Closed
          </span>`;
      } else {
        this.dataSource.dataset[2].plotToolText = `
          <div class="overall-collection-metric-tooltip verified" style='color:${getContrast("#a6cee3")}'>
              <span>$label</span></br>
              $dataValue Querie(s) Closed
          </div>`;
      }
      this.dataExists = this.dataSource.categories && Object.keys(this.dataSource.categories).length > 0;
    },
    xAxisName: function(newValue) {
      this.dataSource.chart.xAxisname = newValue;
    },
    tabQueryStatus: function(newValue) {
      const queriesStatusData = srv.getQueriesStatusData(this.queriesRaw, this.countrySelected, this.sitesSelected, newValue);
      // this.queriesStatusData = queriesStatusData;
      this.category = queriesStatusData.category;
      this.dataOpen = queriesStatusData.dataOpen;
      this.dataResponded = queriesStatusData.dataResponded;
      this.dataClosed = queriesStatusData.dataClosed;
      this.dataExists = this.dataSource.categories && Object.keys(this.dataSource.categories).length > 0;

      this.xAxisNameQueriesStatusData = newValue === 0 ? "Days" : newValue === 1 ? "Activities" : "Sites";
    },
    queriesRaw: function(newValue) {
      const queriesStatusData = srv.getQueriesStatusData(newValue, this.countrySelected, this.sitesSelected, this.tabQueryStatus);
      // this.queriesStatusData = queriesStatusData
      this.category = queriesStatusData.category;
      this.dataOpen = queriesStatusData.dataOpen;
      this.dataResponded = queriesStatusData.dataResponded;
      this.dataClosed = queriesStatusData.dataClosed;
      this.dataExists = this.dataSource.categories && Object.keys(this.dataSource.categories).length > 0;
    }
  },
  mounted() {
    if (this.dataSource.dataset && this.dataSource.dataset[0]) {
      this.dataSource.dataset[0].color = primaryColorFnc();
      if (this.tabQueryStatus === 0) {
        this.dataSource.dataset[0].plotToolText = `
          <span class="overall-collection-metric-tooltip completed" style='color:${getContrast(primaryColorFnc())}'>
              $dataValue Querie(s) Open
          </span>`;
      } else {
        this.dataSource.dataset[0].plotToolText = `
          <div class="overall-collection-metric-tooltip completed" style='color:${getContrast(primaryColorFnc())}'>
              <span>$label</span></br>
              $dataValue Querie(s) Open
          </div>`;
      }
      this.dataSource.dataset[0].toolTipBgColor = primaryColorFnc();
    }
  },
  methods: {
    downloadCSVGraphs(titleChart) {
      const header = ["Day Ranges", "Total Querie(s) Open", "Total Querie(s) Responded", "Total Querie(s) Closed"];
      this.tDateShow = true;
      switch (this.tabQueryStatus) {
        case 0:
          header[0] = "Day Ranges";
          break;
        case 1:
          header[0] = "Activities";
          break;
        case 2:
          header[0] = "Sites";
          break;
        default:
          break;
      }

      const newArr = [];
      this.dataOpen.map(row => {
        newArr.push([row.label, row.value]);
      });

      this.dataResponded.map((row, i) => {
        newArr[i].splice(2, 0, row.value);
      });

      this.dataClosed.map((row, i) => {
        newArr[i].splice(3, 0, row.value);
      });

      downloadCSV(titleChart, header, newArr, this.specificSiteId);
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "240";
        this.$emit("zoomDisabled");
      }
    },
    onTabChange(tabName) {
      this.choosentab = tabName;
      switch (tabName) {
        case "Day Ranges":
          this.dataSource.chart.xAxisname = "Days";
          break;
        case "Activities":
          this.dataSource.chart.xAxisname = "Activities";
          break;
        case "Sites":
          this.dataSource.chart.xAxisname = "Sites";
          break;
        default:
          this.dataSource.chart.xAxisname = "Days";
          break;
      }
    }
  }
};
</script>
